var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("发起申请"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("提交审核"),
      cancelText: _vm.$t("取消"),
      width: 700
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "applicationId",
      label: _vm.$t("发布应用")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("发布应用"),
      allowClear: "",
      "filter-option": _vm.filterOption,
      "show-search": "",
      "option-filter-prop": "children"
    },
    on: {
      change: _vm.getInfoFun
    },
    model: {
      value: _vm.dataFrom.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "applicationId", $$v);
      },
      expression: "dataFrom.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(" " + _vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ")-" + _vm._s(item.customerName) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "versionNumber",
      label: _vm.$t("版本号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("仅支持输入大小写英文字母与数字")
    },
    model: {
      value: _vm.dataFrom.versionNumber,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "versionNumber", $$v);
      },
      expression: "dataFrom.versionNumber"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "platform",
      label: _vm.$t("上线平台")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("多平台用“，”隔开")
    },
    model: {
      value: _vm.dataFrom.platform,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "platform", $$v);
      },
      expression: "dataFrom.platform"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "content",
      label: _vm.$t("优化内容")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请简单描述此次版本更新内容")
    },
    model: {
      value: _vm.dataFrom.content,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "content", $$v);
      },
      expression: "dataFrom.content"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "releaseAt",
      label: _vm.$t("发布日期")
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      format: _vm.getFormatDate()
    },
    model: {
      value: _vm.dataFrom.releaseAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "releaseAt", $$v);
      },
      expression: "dataFrom.releaseAt"
    }
  })], 1), _vm.appType == 1 ? _c("a-form-model-item", {
    attrs: {
      prop: "apkUrl",
      label: _vm.$t("测试版二维码(安卓)")
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      headers: _vm.headers,
      data: {
        module: "applicationVersion"
      }
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.dataFrom.apkUrl ? _c("img", {
    staticStyle: {
      width: "104px",
      height: "104px"
    },
    attrs: {
      src: _vm.dataFrom.apkUrl,
      alt: "avatar"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loading ? "loading" : "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传")) + " ")])], 1)])], 1) : _vm._e(), _vm.appType == 1 ? _c("a-form-model-item", {
    attrs: {
      prop: "iosUrl",
      label: _vm.$t("测试版二维码(iOS)")
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      headers: _vm.headers,
      data: {
        module: "applicationVersion"
      }
    },
    on: {
      change: _vm.handleChange2
    }
  }, [_vm.dataFrom.iosUrl ? _c("img", {
    staticStyle: {
      width: "104px",
      height: "104px"
    },
    attrs: {
      src: _vm.dataFrom.iosUrl,
      alt: "avatar"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loading2 ? "loading" : "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传")) + " ")])], 1)])], 1) : _vm._e(), _vm.appType != 1 && _vm.appType ? _c("a-form-model-item", {
    attrs: {
      prop: "link",
      label: _vm.$t("测试网址")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("http或者https的网址")
    },
    model: {
      value: _vm.dataFrom.link,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "link", $$v);
      },
      expression: "dataFrom.link"
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };